module.exports = __webpack_public_path__ + "static/slider1-2382ba433952de42fe9ad669728980c5.jpg";